import * as Sentry from "@sentry/browser";

function configureSentry() {
  let env = gon.env;
  let env_vars = gon.env_vars;

  if (env === "staging" || env === "production") {
    Sentry.init({
      dsn:         env_vars.sentry_dsn,
      release:     env_vars.version,
      environment: env,
    });
  }
}

export default configureSentry;
